export const DEFAULT_DECIMALS = 2;
